import { CircularProgress } from '@mui/material';

function LoadingSpinner() {
  return (
    <div className="w-full flex justify-center items-center py-14">
      <CircularProgress color="inherit" />
    </div>
  );
}

export default LoadingSpinner;
